import React, { useState } from 'react';
import {Form, Input, Modal, Row, Col, Button, Select} from 'antd';
import Colors from '../../../../styles/Colors'; 
import {BiCheck, BiX} from "react-icons/bi";
import Ingredient from '../../../../model/menudesign/Ingredient'; 
import { UpdateStock } from '../../../../dao/menudesign/UpdateStock'; 

interface IngredientModalProps {
    element: object;
    visible: boolean;
    ingredients : Ingredient[];
    editable : boolean;
    page: string;
    onClose: () => void;
}

const StockModal: React.FC<IngredientModalProps> = ({ element, visible, onClose, ingredients , editable, page}) => {
    const [form] = Form.useForm();
    
    const optionsList = ingredients.map(ingredient =>  ({
        value: ingredient.id,
        label: ingredient.nom,
    }));
        
    
    async function handleSubmit() {
        const id_ingredient = await form.getFieldValue('id_ingredient');
        const quantitat = await form.getFieldValue('quantitat');
        await UpdateStock(id_ingredient, quantitat, page);
        await onClose();
    }

    const handleCancel = () => {
        onClose();
    };

    const filterOption = (input: string, options?: { value: number; label: string }) =>
        (options?.label ?? '').toLowerCase().includes(input.toLowerCase());

    return (
        <Modal
            title="Crear/Editar Stock"
            open={visible}
            onCancel={handleCancel}
            footer={[
                <>
                    <Button title={"Acceptar"} style={{backgroundColor: Colors.colors.color6}}
                            onClick={handleSubmit}><BiCheck/></Button>
                    {" "}
                    <Button title={"Cancelar"} style={{backgroundColor: Colors.colors.color1}}
                            onClick={handleCancel}><BiX/></Button>
                </>
            ]}
            width={400}
        >
            <Form form={form} initialValues={element} >
                <Row gutter={[16, 16]}>
                    <Col>
                        <Form.Item label="ID" name="id">
                            <Input disabled />
                        </Form.Item>
                        <Form.Item label="Ingredient" name="id_ingredient" required>
                            <Select
                                {...(editable ? {} : { disabled: true })}
                                showSearch
                                placeholder="Selecciona un ingredient"
                                optionFilterProp="children"
                                filterOption={filterOption}
                                options={optionsList}
                            />
                        </Form.Item>
                        <Form.Item label="Quantitat" name="quantitat" required>
                            <Input type="number"  />
                        </Form.Item>
                        <Form.Item label="Unitat de Mesura" name="mesura">
                            <Input disabled />
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
        </Modal>
    );
};

export default StockModal;
